import { useEffect, useState, useMemo } from 'react';
import { useCurrentProjectId } from '@adsk/alloy-provider';
import { useLocale } from '@adsk/alloy-react-helpers';
import { useGetPermissions } from '@adsk/acs-progress-tracking-apollo-hooks';
import { useFormikContext } from 'formik';
import { getProgressTrackingPermissionsInfo } from './utils';

const useProgressTrackingPermissions = () => {
  const [permissionsInfo, setPermissionsInfo] = useState({ loading: true });
  const projectId = useCurrentProjectId();
  const { values } = useFormikContext();
  const {
    member: {
      autodeskId: memberAutodeskId,
      selectedRoles,
      selectedAccessLevel,
    },
  } = values;
  const options = useMemo(() => {
    const subjects = [
      memberAutodeskId,
      ...(selectedRoles ? selectedRoles.map((role) => role.memberGroupId) : []),
    ];
    return {
      variables: {
        project: { uid: projectId },
        input: {
          filters: { subjects },
          page: { after: null, first: 1000 },
        },
      },
    };
  }, [projectId, memberAutodeskId, selectedRoles]);
  const input = useMemo(() => ({}), []);
  const { data: ptPermissionData, loading } = useGetPermissions(input, options);
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  useEffect(() => {
    if (!ptPermissionData) return;

    const memberPermissions = memberAutodeskId
      ? ptPermissionData.find(
          (permission) => permission.uid === memberAutodeskId
        )
      : null;
    const rolesPermissions = selectedRoles
      ? ptPermissionData.filter((permission) =>
          selectedRoles.some((role) => role.memberGroupId === permission.uid)
        )
      : [];

    const info = getProgressTrackingPermissionsInfo(
      memberPermissions,
      rolesPermissions,
      selectedAccessLevel?.value,
      selectedRoles,
      T
    );

    setPermissionsInfo(info);
  }, [
    ptPermissionData,
    memberAutodeskId,
    selectedAccessLevel,
    selectedRoles,
    T,
  ]);

  useEffect(() => {
    if (loading || loading === undefined) return;

    if (!ptPermissionData) setPermissionsInfo({ loading: false });
  }, [loading, ptPermissionData]);

  return permissionsInfo;
};

export default useProgressTrackingPermissions;
